export const costs = [
  'Impari il vino da fonti sparse che non si collegano tra loro',
  "Davanti a un'etichetta o a una carta dei vini non sai bene cosa scegliere",
  'Abbinamenti fatti a caso e paura di sbagliare con clienti o amici',
  'Degusti senza un metodo chiaro e non sai descrivere ciò che senti',
];
